



















































import Vue from "vue";
import { RoomDetail } from "@/models/room";
import VaInfoRow from "@/components/molecules/VaInfoRow.vue";

export default Vue.extend({
  name: "RoomInformationIos",
  components: { VaInfoRow },
  computed: {
    room(): RoomDetail {
      return this.$store.getters["room/room"];
    },
  },
});
